

import '@/assets/scss/index.scss'
import { pdMixin } from '@/mixin/pd/pdMixin'

export default {
  components: {
  },
  mixins: [pdMixin],
  props: {
    crumbs: { // bread crumbs
      type: Array,
      default: () => []
    }
  },
  data () {
    return {}
  },
  computed: {
  },
  mounted () {
  },
  methods: {
  }
}
